import React, { FC } from 'react';
import styled from 'styled-components';
import { ICookieButton } from '../../interfaces/umbracoNodes/contentSlices';
import { asAnchor } from '../base/typography';
import { ContentContainer } from '../base/contentContainer/contentContainer';

type Props = {
	content: ICookieButton;
};

const CookieButton: FC<Props> = ({ content }) => {
	return (
		<ContentContainer>
			<AnchorStyled
				href="#"
				title={content.Values.Title}
				onClick={e => {
					e.preventDefault();
					// @ts-ignore
					if (window.cookiehub) {
						// @ts-ignore
						window.cookiehub.openDialog();
					}
				}}>
				{content.Values.Title}
			</AnchorStyled>
		</ContentContainer>
	);
};

export default CookieButton;

const AnchorStyled = styled.a`
	${asAnchor};
	font-size: 20px;
`;
